import { useEffect, useState } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link,useOutletContext } from "react-router-dom";
import { currency_converter_inr, currency_converter_selected } from "../../../utils/currencyUtils";
import ProgressBar from "react-bootstrap/ProgressBar";
import { MaterialReactTable } from "material-react-table";
function Roles() {
  const { selectedUser, year, setGlobalLoading, token } = useOutletContext();
  const [data, setData] = useState([]);
  const [options, setoptions] = useState([]);
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [filterType, setFilterType] = useState("all");
  const [allRoles, setAllRoles] = useState([]);
    function RevenueCounter({ value, format = true }) {
        const safeValue = Number(value) || 0;
        return (
            <CountUp
                start={0}
                end={safeValue}
                duration={1}
                formattingFn={format ? currency_converter_selected : undefined}
            />
        );
    }  

    const handleFilter = (type) => {
        if (filterType === type) {
            setFilterType("all");
            setoptions(allRoles);
            return;
        }

        setFilterType(type);

        const filtered = allRoles.filter((item) => {
            const status = item.role_status?.toLowerCase();
            const role_type = item.role_type?.toLowerCase();
            const closedFlag = item.closed_in_current_fy;

            if (type === "prospective") return status === "prospective";
            if (type === "active") { return ["active"].includes(status);}
            if (type === "closed") {return status === "closed" && closedFlag === 1;}
            if (type === "other_closed") {return status === "closed" && closedFlag === 0;}
            if (type === "inactive") { return ["on hold", "inactive", "shelved"].includes(status);}
            if (type === "talent_scan") { return ["talent scan", "report", "org consulting"].includes(role_type);}

            return true;
        });

        setoptions(filtered);
        };

  useEffect(()=>{
    if(!selectedUser) return;
    let isLatest = true; 
    const getOverview = async ()=>{
    try{
    setGlobalLoading(true);    
    const response = await axios.get(`${REACT_APP_API_BASE_URL}/performance/roles`,
     {
        params:{ user_id:selectedUser.id, year:year },
        headers: { Authorization: `Bearer ${token}` },
     }
    );
     if (!isLatest) return;
    const d = response.data;
    console.log(response.data.role_summary);
    setoptions(response.data.role_summary || []);
    setAllRoles(response.data.role_summary || []);
    console.log("roles response", response.data);
    const total_roles = response.data.role_list[0].role_count;
    // const other_closed_roles = response.data.role_list[0].role_count - response.data.role_list[0].active_roles - response.data.role_list[0].inactive_roles - response.data.role_list[0].closed_roles;
    const other_closed_roles = Math.max(
  0,
  response.data.role_list[0].role_count -
    response.data.role_list[0].active_roles -
    response.data.role_list[0].inactive_roles -
    response.data.role_list[0].closed_roles
);
    // const total_roles = response.data.role_list?.[0]?.prospective_roles + response.data.role_list?.[0]?.active_roles + response.data.role_list?.[0]?.inactive_roles + response.data.role_list?.[0]?.closed_roles;
    if(response.status === 200) {
        setData({
          ...d,
          total_roles,
          other_closed_roles,
        });
    }

    }catch (error) {
        console.log(error);
        setGlobalLoading(false);
      } finally {
        setGlobalLoading(false);
      }
    };
    getOverview();
     return () => {
        isLatest = false; // cancel old request
    };
    },[selectedUser,year]);

 const columns = [
    {
      accessorKey: "role_name",
      header: "Role Name",
      size: 300,
      muiTableHeadCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 3,
          backgroundColor: "white",
          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
        },
      },
      muiTableBodyCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 1,
          backgroundColor: "white",
          boxShadow: "2px 0 5px -2px rgba(0,0,0,0.3)", // border/shadow effect
        },
      },
      Cell: ({ row }) => {
        return (
          <div className="d-flex align-items-center file-name-icon">
            <div className="ms-2">
              <h6 className="fw-medium mb-0">
                <Link
                  to={`/role/view/${row.original.role_id}`}
                >
                  {row.original.role_name}
                </Link>
              </h6>
            </div>
          </div>
        );
      },
    },
    {
      accessorKey: "company_name",
      header: "Client",
      size: 100,
    },
    {
      accessorKey: "assignedTo",
      header: "Assigned To",
      size: 100,
    },
    {
      accessorKey: "role_status",
      header: "Status",
      size: 100,
    },
    {
      accessorKey: "averageFee",
      header: "Fee %",
      size: 100,
      Cell: (info) => {
        const value = Number(info.cell.getValue());

        if (!value) return "NA";

        return value > 100 ? value : `${value}%`;
      },
    },
    {
      accessorKey: "vobt",
      header: "VOBT",
      size: 70,
      Cell: (info) => {
        const value = currency_converter_selected(info.cell.getValue() ?? 0);
        return `${value}K`;
        }
    },
    {
      accessorKey: "weeks_spent",
      header: "Weeks",
      size: 50,
    },
    {
      id: "allocations",
      header: "Resources",
      accessorFn: (row) => row.allocations || [],
      size: 120,
      Cell: ({ row }) => {
        const allocations = row.original.allocations || [];

        if (!allocations.length) return "-";

        return (
          <div className="avatar-list-stacked avatar-group-sm">
            {allocations.map((allocation, index) => (
              <span
                key={index}
                className="avatar avatar-rounded ms-1"
                title={allocation.allocated}
              >
                <img
                  src={`${PINE_BASE_URL}/files/media/${allocation.userpic}`}
                  className="border border-white"
                  alt={allocation.allocated}
                />
              </span>
            ))}
          </div>
        );
      },
    },
    // {
    //   accessorKey: "allocation",
    //   header: "Resources",
    //   size: 50,
    // },
    // {
    //   accessorKey: "closed_in_current_fy",
    //   header: "Current FY",
    //   size: 50,
    // },
    {
      accessorKey: "role_type",
      header: "Role Type",
      size: 100,
    },
  ];


  return (
    <>
      <div className="card">
        <div className="card-body">
          <div className="border-bottom mb-3 pb-3">
            <h4>Roles</h4>
            <p className="text-muted fs-13 mb-1">Search pipeline & performance tracking</p>
          </div>
          <div className="row">
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-briefcase`}></i>
                                Total Roles
                            </p>
                            <h3 className="counter"><RevenueCounter value={Number(data?.total_roles || 0)} format={false}/></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-clock`}></i>
                                Avg Weeks
                            </p>
                            <h3 className="counter"><RevenueCounter value={Number(data?.role_list?.[0]?.avg_weeks_spent)} format={false} /></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-money-bill-wave`}></i>
                                Avg VOBT
                            </p>
                            <h3 className="counter"><RevenueCounter value={Number(data?.average_vobt?.[0]?.avg_vobt || 0)} /></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div> 
            <div className="col-xl-3 col-md-6 d-flex">
                <div className="card flex-fill cursor-pointer">
                    <div className="card-body my-card-body">
                        <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                        <div>
                            <p className="fs-12 fw-medium mb-0 text-gray-5 mb-1">
                                <i className={`fa-solid me-1 fa-exclamation-triangle`}></i>
                                High Risk Roles
                            </p>
                            <h3 className="counter text-warning"><RevenueCounter value={Number(data?.highRiskCount || 0)} format={false} /></h3>
                        </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div> 
          </div>
          <div className="d-flex align-items-center flex-wrap row-gap-2 mb-2">
                <h5>Pipeline Funnel</h5>
          </div>
          <div className="row">
            <div className="col-xl-2 col-md-6">
            <div className={`card flex-fill cursor-pointer ${filterType === "prospective" ? "border border-primary" : ""}`} onClick={() => handleFilter("prospective")}>    
                <div className="card-body my-card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    Prospective <span className="fs-14 fw-medium mb-0 text-primary mb-1 ms-1">{data?.role_list?.[0]?.prospective_roles || 0}</span>
                </div>
                <div className="progress progress-md">
                    <ProgressBar
                    animated
                    max={data?.total_roles || 1}
                    variant="primary"
                    now={data?.role_list?.[0]?.prospective_roles || 0}
                    />
                </div>
                </div>
            </div>    
            </div>
            <div className="col-xl-2 col-md-6">
            <div className={`card flex-fill cursor-pointer ${filterType === "active" ? "border border-success" : ""}`} onClick={() => handleFilter("active")}>
                <div className="card-body my-card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    Active <span className="fs-14 fw-medium mb-0 text-success mb-1 ms-1">{data?.role_list?.[0]?.active_roles || 0}</span>
                </div>
                <div className="progress progress-md">
                    <ProgressBar
                    animated
                    max={data?.total_roles || 1}
                    variant="success"
                    now={data?.role_list?.[0]?.active_roles || 0}
                    />
                </div>
                </div>
            </div>    
            </div>
            <div className="col-xl-2 col-md-6">
            <div className={`card flex-fill cursor-pointer ${filterType === "closed" ? "border border-warning" : ""}`} onClick={() => handleFilter("closed")}>   
                <div className="card-body my-card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    Closed (This FY) <span className="fs-14 fw-medium mb-0 text-warning mb-1 ms-1">{data?.role_list?.[0]?.closed_roles || 0}</span>
                </div>
                <div className="progress progress-md">
                    <ProgressBar
                    animated
                    max={data?.total_roles || 1}
                    variant="warning"
                    now={data?.role_list?.[0]?.closed_roles || 0}
                    />
                </div>
                </div>
            </div>    
            </div>
            <div className="col-xl-2 col-md-6">
            <div className={`card flex-fill cursor-pointer ${filterType === "other_closed" ? "border border-primary" : ""}`} onClick={() => handleFilter("other_closed")}>   
                <div className="card-body my-card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    Closed (Other FY) <span className="fs-14 fw-medium mb-0 text-primary mb-1 ms-1">{data?.other_closed_roles || 0}</span>
                </div>
                <div className="progress progress-md">
                    <ProgressBar
                    animated
                    max={data?.total_roles || 1}
                    variant="primary"
                    now={data?.other_closed_roles || 0}
                    />
                </div>
                </div>
            </div>    
            </div>
            <div className="col-xl-2 col-md-6">
            <div className={`card flex-fill cursor-pointer ${filterType === "inactive" ? "border border-danger" : ""}`} onClick={() => handleFilter("inactive")}>    
                <div className="card-body my-card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    Inactive <span className="fs-14 fw-medium mb-0 text-danger mb-1 ms-1">{data?.role_list?.[0]?.inactive_roles || 0}</span>
                </div>
                <div className="progress progress-md">
                    <ProgressBar
                    animated
                    max={data?.total_roles || 1}
                    variant="denger"
                    now={data?.role_list?.[0]?.inactive_roles || 0}
                    />
                </div>
                </div>
            </div>    
            </div>
            <div className="col-xl-2 col-md-6">
            <div className={`card flex-fill cursor-pointer ${filterType === "talent_scan" ? "border border-info" : ""}`} onClick={() => handleFilter("talent_scan")}>    
                <div className="card-body my-card-body">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    Talent Scan <span className="fs-14 fw-medium mb-0 text-info mb-1 ms-1">{data?.role_list?.[0]?.talent_scan || 0}</span>
                </div>
                <div className="progress progress-md">
                    <ProgressBar
                    animated
                    max={data?.total_roles || 1}
                    variant="info"
                    now={data?.role_list?.[0]?.talent_scan || 0}
                    />
                </div>
                </div>
            </div>    
            </div>
          </div> 

          <div className="row">
            <div className="card-body p-0">
            <div className="custom-datatable-filter table-responsive">
              <MaterialReactTable
                columns={columns}
                data={options}
                initialState={{
                  pagination: { pageSize: 200 },
                }}
                muiTableBodyRowProps={{
                  sx: {
                    height: "20px", // compact row height
                  },
                }}
                muiTableBodyCellProps={{
                  sx: {
                    padding: "2px 4px", // compact cell padding
                  },
                }}
                muiTableHeadCellProps={{
                  sx: {
                    padding: "2px 4px", // same as body cells
                    height: "30px", // or less
                  },
                }}
              />
            </div>
          </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Roles;
